import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=617857fc&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('617857fc')) {
      api.createRecord('617857fc', component.options)
    } else {
      api.reload('617857fc', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=617857fc&", function () {
      api.rerender('617857fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8MyGEUGugyupz/JS/comp/ImgFallback.vue"
export default component.exports